import { FacilityLevelsOfCareTable } from '@/entities/facility';
import type { FacilityLevelsOfCareDto } from '@/shared/api/modules/facilities';
import { Tabs, Typography, type TabOption } from '@/shared/ui';
import { RatesAndRevenueTable } from '@/widgets/rates-and-revenue-table';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { useState, type FC } from 'react';
import { LevelsOfCareTabId } from '../model/types';

const tabs: TabOption[] = [
  {
    id: LevelsOfCareTabId.Overview,
    label: 'Overview',
  },
  {
    id: LevelsOfCareTabId.Rates,
    label: 'Rates',
  },
];

type LevelsOfCareTabsProps = {
  /** Omit for the All Facilities view. */
  facilityId?: string;
  onRowHover: (levelOfCareData: FacilityLevelsOfCareDto) => void;
  onHoverEnd: () => void;
  dateRange: {
    from: Dayjs;
    to: Dayjs;
  };
};

export const LevelsOfCareTabs: FC<LevelsOfCareTabsProps> = ({
  facilityId,
  dateRange,
  onHoverEnd,
  onRowHover,
}) => {
  const [activeTabId, setActiveTabId] = useState<LevelsOfCareTabId>(
    LevelsOfCareTabId.Overview
  );

  const formattedFrom = dayjs(dateRange.from).format('MMM DD');
  const formattedTo = dayjs(dateRange.to).format('MMM DD YYYY');

  const formattedDateRange = formattedFrom + ' - ' + formattedTo;

  return (
    <div className="flex flex-col gap-3">
      <div className="flex w-full items-center justify-between">
        <Tabs
          tabs={tabs}
          activeTabId={activeTabId}
          onChangeTab={(tab) => setActiveTabId(tab as LevelsOfCareTabId)}
        />

        <Typography className="text-neutral-9">
          {activeTabId === LevelsOfCareTabId.Overview
            ? formattedDateRange
            : 'Current Status'}
        </Typography>
      </div>

      {activeTabId === LevelsOfCareTabId.Overview && (
        <FacilityLevelsOfCareTable
          dateRange={dateRange}
          facilityId={facilityId}
          onHoverEnd={onHoverEnd}
          onRowHover={onRowHover}
        />
      )}
      {activeTabId === LevelsOfCareTabId.Rates && (
        <RatesAndRevenueTable
          facilityId={facilityId}
          onHoverEnd={onHoverEnd}
          onRowHover={(data) => onRowHover(data as FacilityLevelsOfCareDto)}
        />
      )}
    </div>
  );
};
